<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <multiselect
            :value="value"
            :options="options"
            :close-on-select="true"
            :clear-on-select="false"
            :placeholder="props.placeholder"
            :disabled="disabled"
            :loading="loading"
            :show-labels="false"
            label="nombre"
            track-by="id"
            @input="$emit('input', $event)"
        >
            <template slot="singleLabel" slot-scope="props">
                <img
                    :src="getFlagUrl(props.option.iso)"
                    :alt="props.option.nombre"
                    :title="props.option.nombre"
                    class="flag-selected"
                />
            </template>

            <template slot="option" slot-scope="props">
                <img
                    :src="getFlagUrl(props.option.iso)"
                    :alt="props.option.nombre"
                    :title="props.option.nombre"
                    class="flag-option"
                />
            </template>

            <template slot="noOptions">
                {{ props.noOptionsText }}
            </template>
        </multiselect>
    </div>
</template>

<script setup>
    const props = defineProps({
        value: { type: Object, default: null },
        options: { type: Array, required: true },
        loading: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        label: { type: String, default: ''},
        placeholder: { type: String, default: '' },
        noOptionsText: { type: String, default: ''}
    });

    const getFlagUrl = codigo => {
        if (!codigo) return '';
        return `https://flagcdn.com/w40/${codigo.toLowerCase()}.png`;
    }
</script>

<style scoped>
.flag-selected, .flag-option {
    height: 20px;
    width: 35px;
    object-fit: cover;
    border: 1px solid #ddd;
    border-radius: 2px;
}
</style>
